import { queryOptions } from '@tanstack/react-query';
import type { HevitonApiAppLegacy } from '@heviton/heviton-api-app-legacy';
import { fromRawPlantProfile } from '@/shared/data-mappers';
import type { PlantProfile } from '@/shared/data-types';

/**
 * 발전소 프로필(정보 상세) query 정의 SSOT — 기본/설치/계약 3섹션. BE = app-legacy(v3)
 * `GET /plants/{id}/profile`. 응답 없음(null)은 매퍼가 보존 → 위젯이 에러/빈 상태로. plantId 는 web 문자열,
 * mirror 는 number → `Number()` 강제(수치 plantId 가정).
 */
export const plantProfileQueryKey = (plantId: string) => ['plant', 'profile', plantId] as const;

export const plantProfileQueryOptions = (api: HevitonApiAppLegacy, plantId: string) =>
  queryOptions<PlantProfile | null>({
    queryKey: plantProfileQueryKey(plantId),
    queryFn: async ({ signal }) =>
      fromRawPlantProfile(await api.plant.getProfile(Number(plantId), { signal })),
  });
